<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/3Jl5ak/tc-custom/9781963011067.jpg?1723518792889" alt="This image is the cover for the book Way Beyond, Mockingbird Bridge"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Way Beyond, Mockingbird Bridge
      </h1>
      <p class="bookDescription body article font2">
        <p><i>When she finds out his secret, will he lose her for good?</i></p><p> Jacob Winters has a secret: he’s come to Colton undercover as an FBI handler. He didn’t plan<br/> to stay, but the small town has charmed him with a sense of community that he hasn’t felt in a<br/> long time. And his attraction to the beautiful Mae Colton complicates things even more. Jacob<br/> doesn’t do relationships—he won’t risk making memories he might regret. </p><p> Mae Colton loves her little town of Colton, Mississippi, and doesn’t want to leave. In fact,<br/> instead of moving on to bigger things—namely a political career in D.C.-like she’d planned, she<br/> wants to run for a second term as mayor of Colton. But not everyone in town supports this<br/> choice, including the commitment-phobic Jacob Winters. </p><p> Mae is ready to make their secret relationship official and go public, but that would break<br/> Jacob’s one rule. When a threat against Mae’s life forces him to admit the truth of his feelings,<br/> he has to race to save the woman he loves before it’s too late. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Eliana West
      </h2>
      
      <p class="authorDescription body article"><P> Eliana West, the recipient of the 2022 Nancy Pearl Award for genre fiction, is committed to embracing diversity in her writing. That means she doesn&rsquo;t limit herself to a single genre. Instead, Eliana welcomes every story that comes her way with open arms. She aims to create characters that reflect the diversity of her community, with a range of social backgrounds, ethnicities, genders, and sexual orientations. Eliana loves to weave in historical elements whenever she can. She believes everyone deserves a happy ending.<BR /> &#160;<BR /> From small towns to close-knit communities, Eliana West loves stories that bring people from different backgrounds together through the common language of unconditional love and acceptance. Eliana is a passionate advocate for diversity within the writing community. She is the founder of Writers for Diversity and teaches classes and workshops, encouraging writers to create diverse characters and worlds with an empathetic approach.<BR /> &#160;<BR /> When Eliana isn&rsquo;t plotting her characters&rsquo; happy endings, she can be found embarking on adventures with her husband, traversing winding country roads in their beloved vintage Volkswagen Westfalia, affectionately named Bianca. Whether it&rsquo;s traveling abroad or exploring locally, Eliana and her husband are always willing to get lost and see where the adventure takes them.<BR /> &#160;<BR /> Eliana loves connecting with readers through her website: www.elianawest.com.<BR /> &#160; </P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Second Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?68ab92f4